<template>
  <div class="contactUs" v-on:scroll="handleScroll(event)" style="  overflow: hidden;">
    <div id="homeside">
      <a href="https://www.facebook.com/kingstonecy1986/">
      <img src="./../assets/icon-fb/icon-fb-m.png"
            srcset="./../assets/icon-fb/icon-fb-m@2x.png 2x,
                   ./../assets/icon-fb/icon-fb-m@3x.png 3x"
            class="icon">
      </a>
      <a href="mailto:cs@kingstonecy.com.tw" target="_blank">      
        <img src="./../assets/icon-mail/icon-mail-m.png"
          srcset="./../assets/icon-mail/icon-mail-m@2x.png 2x,
                  ./../assets/icon-mail/icon-mail-m@3x.png 3x"
          class="icon"></a>
    </div> 
    <div class="container">
      <div class="article" style="z-index:10;">
        <img src="./../assets/kmap/kmap.png"
            srcset="./../assets/kmap/kmap@2x.png 2x,
                    ./../assets/kmap/kmap@3x.png 3x"
            class="kmap">
      </div>
      <div class="figure">
        <ul id="address">
          <li class="list-label">地址</li>
          <li class="list-content">嘉義市西區長榮街303號</li>
          <li class="list-label">預約專線</li>
          <li class="list-content">05-2316999</li>
          <li class="list-label">傳真</li>
          <li class="list-content">05-2249611</li>
          <li class="list-label">客服電話</li>
          <li class="list-content">0800-520-919</li>
          <li class="list-label">客服信箱</li>
          <li class="list-content">cs@kingstonecy.com.tw</li>
          <li style="margin-top:50px;margin-bottom:-50px;">商業交流歡迎蒞臨指教</li>
        </ul>
      </div>
    </div>
    <svg xmlns="http://www.w3.org/2000/svg" v-if="width < 1600" :class="'stroke '+ this.className_theLINE " 
         width="1280" height="279" viewBox="0 0 1280 279" style="margin-left: 80px; margin-top: -50px; margin-bottom: -50px;">
      <path fill="none" fill-rule="evenodd" stroke="#BBB" stroke-linecap="square" d="M1 0v155.825h645V213"/>
    </svg>
    <svg xmlns="http://www.w3.org/2000/svg" v-else-if="(1600 <= width) && (width <= 1800)" :class="'stroke '+ this.className_theLINE " 
         width="1680" height="279" viewBox="0 0 1680 279" style="margin-left: 80px; margin-top: -80px;">
      <path fill="none" fill-rule="evenodd" stroke="#BBB" stroke-linecap="square" d="M1 0v185.825h759V253"/>
    </svg>
    <svg xmlns="http://www.w3.org/2000/svg" v-else-if="1800 < width" :class="'stroke '+ this.className_theLINE " 
         width="1920" height="379" viewBox="0 0 1920 379" style="margin-left: 80px; margin-top: -150px; margin-bottom: 0px;">
      <path fill="none" fill-rule="evenodd" stroke="#BBB" stroke-linecap="square" d="M1 0v285.825h879V353"/>
    </svg>
    <div :class="'form-container '+this.className_theFLOW">
      <div id="form-label">歡迎洽詢</div>
      <div id="form-content">
        <div id="left-content">
          <div class="form-group"><span class="label-group">主旨</span><input class="text-group" type="text" name="subject" v-model="mail.subject"/></div>
          <div class="form-group"><span class="label-group">姓名</span><input class="text-group" type="text" name="name" v-model="mail.name"/></div>
          <div class="form-group"><span class="label-group">Email</span><input class="text-group" type="email" name="email" v-model="mail.address"/></div>
          <div class="form-group" style="margin-bottom:0;"><span class="label-group">電話</span><input class="text-group" type="text" v-model="mail.phone"/></div>
        </div>
        <div id="right-content">
          <div class="label-textarea">來信內容</div>             
          <textarea class="content-textarea" v-model="mail.content"></textarea>             
        </div>
      </div>
      <div id="form-btn">
        <button type="submit" id="submit-btn" @click="sendMail(mail)">確認送出</button>
      </div>
    </div>
  </div>
  
</template>
<script>
export default {
  data(){
    return {      
      width:"",   windowscrollY:"",
      className_theLINE:'', className_theFLOW:'', 
      mail:{
        subject:'', 
        name:'', 
        address:'', 
        phone:'',
        content:''  },
        subject:'', 
        name:'', 
        address:'', 
        phone:'',
        content:'' ,
        whitespace:''
      }
  },
  methods: {
      handleResize() {
        this.width = window.innerWidth;
        this.height = window.innerHeight;
      },
      handleScroll (event) {
        this.windowscrollY = window.scrollY
        // console.log(this.windowscrollY)
        if (this.windowscrollY > 130) {
            this.className_theLINE = 'theLINE'
            // console.log(this.className+'foo')
        // Any code to be executed when the window is scrolled
      }
      if(this.windowscrollY > 455){
            this.className_theFLOW = 'theFLOW'
      }
      // else console.log('no')
      },
      sendMail(mail) {
        this.address = mail.address
        if(this.address == ''){
          alert("不好意思，請您提供電子郵件信箱！");
        }else{ 
          this.address = mail.address
          this.senddetail(mail)
        }   
   },      
      senddetail(mail) {
        this.subject = mail.subject
        if(this.subject == ''){
          this.subject ='詢問金石建設相關服務事項'
        }else{ 
          this.subject = mail.subject
        }
        this.name = mail.name
        if(this.name == ''){
          this.name = '未提供姓名/公司行號'
        }else{ this.name = mail.name
        }

        this.phone = mail.phone
        if(this.phone == ''){
          this.phone = '未提供電話'
        }else{ 
          this.phone = mail.phone
        }
        this.content = mail.content
        if(mail.content == ''){
          this.content = '請直接來電或來信聯絡，謝謝！'
        }else{ 
          this.content = mail.content
        }
        this.date_year = new Date().getFullYear()
        this.date_month = new Date().getMonth()+ 1
        this.date_day = new Date().getDate()
        
        this.date_time_hour = new Date().getHours()
        if(this.date_time_hour < 10){
          this.date_time_hour = '0'+new Date().getHours()
        }else{
          this.date_time_hour = new Date().getHours()
        }
        this.date_time_minute = new Date().getMinutes()
        if(this.date_time_minute < 10){
          this.date_time_minute = '0'+new Date().getMinutes()
        }else{
          this.date_time_minute = new Date().getMinutes()
        }
        this.date_time_sec =  new Date().getSeconds()
        if(this.date_time_sec < 10){
          this.date_time_sec = '0'+new Date().getSeconds()
        }else{
          this.date_time_sec = new Date().getSeconds()
        }
        this.date_time = this.date_time_hour + ':' + this.date_time_minute + ':' + this.date_time_sec
        this.date_weekday = new Date().getDay()
        if(this.date_weekday == 0){
          this.date_weekday = 'Sun'
        }else if(this.date_weekday == 1){
          this.date_weekday = 'Mon'
        }else if(this.date_weekday == 2){
          this.date_weekday = 'Tue'
        }else if(this.date_weekday == 3){
          this.date_weekday = 'Wed'
        }else if(this.date_weekday == 4){
          this.date_weekday = 'Thu'
        }else if(this.date_weekday == 5){
          this.date_weekday = 'Fri'
        }else if(this.date_weekday == 6){
          this.date_weekday=  'Sat'
        }
        this.date = this.date_year+'-'+this.date_month+'-'+this.date_day+' '+this.date_weekday+' '+this.date_time
        // alert("感謝您的來信，我們會盡快請專人與您聯繫！");
        window.open(
          'mailto:cs@kingstonecy.com.tw?subject='+this.subject+' - ' +this.name + ' (' + this.address + ')'
           + '&body=' + '%0D%0A' +'客戶來信內容/需求：' + '%0D%0A' + this.content + '%0D%0A' + '%0D%0A' + '------------------------- 聯絡方式 -------------------------' + '%0D%0A' + '姓名/公司名稱： ' + this.name + '%0D%0A' + '電子郵件： '+ this.address + '%0D%0A' + '電話：' + this.phone + '%0D%0A' +'----------------------------------------------------------------'+ '%0D%0A' + '%0D%0A' + '%0D%0A' + '煩請您儘速來電/聯絡' + '%0D%0A' + '來信日期：' + this.date, '_blank')
        
         
      }
  },
  created () {
      window.addEventListener('resize', this.handleResize)
      this.handleResize();
      window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
      window.removeEventListener('resize', this.handleResize)      
      window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>
<style scoped>
.about{
  width: 100%;
  height: auto;
  margin:0;
}

#homeside, .article, .figure{
  display: inline-block;
}

#homeside{
  position:relative;
  text-align: center;
  float: left;
  width: 46px;
  height: auto;
  margin: 300px 120px 10px 48px;
}
.icon {
  position:relative;
  height: 28px;
  margin: 9px 18px;
  object-fit: contain;
}
.icon:hover{
  cursor: pointer;
}
.container{
  width: 100%;
  margin:  0;
}
.article{  
  float: left;
  display: block;
  width:28%;
  margin:0 ;
  opacity: 0;
  animation: showuparticle 1s ease-in-out forwards;
  -webkit-animation: showuparticle 1s ease-in-out forwards;
  animation-delay: 0s;
	-webkit-animation-delay: 0s;
  }

@keyframes showup{
    0%{
      transform: translateY(10px);
    }
    100% {
        opacity: 1;
        }
    }
@keyframes showuparticle{
    0%{
      transform: translateY(14px);
    }
    100% {
        opacity: 1;
        }
    }
.figure{
  margin: -2% 0 0 1%;
  padding-bottom: 40px;
  padding-top: 10%;
  padding-left: 10%;
  float: right;
  display: block;
  width:45%;
  z-index: 0;
  /* width: 700px;
  height: 520px; */
  background-image: linear-gradient(320deg, #c4c3c283, #dadad9 3%, #ebebeb 18%, #feffffa2, #ffffff);
}
#address{
  margin: -15% 0 20% 20%;
  width: 381px;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.88;
  letter-spacing: 1.27px;
  text-align: justify;
  color: #7d7d7d;
  list-style-type:none;
  opacity: 0;
  animation: showuparticle 1s linear forwards;
  -webkit-animation: showuparticle 1s linear forwards;
  animation-delay: 1s;
	-webkit-animation-delay: 1s;
}
.list-label{ margin: 5px 0 0 0; }
.list-content{ margin: 0 0 20px 0; }
.stroke{
    stroke-dashoffset: 2000;
    stroke-dasharray: 2000;
}
.theLINE{
  animation: circle-draw 3.2s ease-in-out forwards;
  -webkit-animation: circle-draw 3.2s ease-in-out forwards;
  animation-delay: 0s;
	-webkit-animation-delay: 0s;
}

@keyframes circle-draw{
    100% {
        stroke-dashoffset: 0;
        }
    }
.form-container{ 
  opacity: 0;
}
.form-container.theFLOW{
  animation: showuparticle 1s linear forwards;
  -webkit-animation: showuparticle 1s linear forwards;
  animation-delay: 0.5s;
  -webkit-animation-delay: 0.5s;
}
#form-label{
  text-align: center;
  width: 100%;
  height: 34px;
  opacity: 0.84;
  font-size: 28px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 3px;
  color: #a89a80;
  margin: 0;
}
#form-content{   
  text-align: center;
  width: 100%;
  margin: 5% 0;
}
#left-content, #right-content{ 
  display: inline-block;
  width: 30%;
  margin: auto 2.6%;
}
.form-group{
  display: block;
  height: 75px;
  margin: 10px 0; 
  border-bottom: solid 1px #bbbbbb;
}
.label-group {
  float: left;
  margin: 40px 0 -10px 0;
  padding: 1px;
  width: 35px;
  height: 40px;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.88;
  letter-spacing: 1.27px;
  text-align: justify;
  color: #7d7d7d;
}
.text-group{
  margin: 35px 0 -10px 0;
  width: 335px;
  height: 40px;
  padding: -5px 10px 5px 10px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  font-size: 16px;
  line-height: 1.88;
  letter-spacing: 1.57px;
  text-align: center;
  color: #7d7d7d;
  background: transparent;
  /* border: solid 1px #7d7d7d; */
  border: none;
  overflow: auto;
  outline: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  resize: none;   
}
.label-textarea {
  float: left;
  margin: 40px 0 -6px 0;
  height: 40px;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.88;
  letter-spacing: 1.27px;
  text-align: justify;
  color: #7d7d7d;
}
.content-textarea{
  width: 100%;
  height: 257px;
  margin: 0 0 -8px 0;
  padding: 0 10px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  font-size: 16px;
  line-height: 2.88;
  letter-spacing: 1.57px;
  text-align: justify;
  color: #7d7d7d;
  border: #bbbbbb 1px solid;
  overflow: auto;
  outline: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  resize: none; 
}
#form-btn{   
  text-align: center;
  width: 100%;
  margin: 7% 0 10% 0;
}
#submit-btn{ 
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.88;
  letter-spacing: 1.27px;
  text-align: justify;
  color: #d0ad76;
  padding: 13px 30px 16px 30px;
  background: transparent;
  border: solid 1px #d0ad76;
}
#submit-btn:hover{
  color: #ffffff;
  background: #e4c798;
  border: solid 1px #e4c798;
  cursor: pointer;
}
@media screen and (min-width:1600px) and (max-width:1800px){
.article{  
  margin: 3% 0 3% 2%;
  }
.figure{
  margin: 1% 0 0 1%;
  padding-bottom: 8%;
  padding-top: 10%;
  padding-left: 10%;
  }
}
@media screen and (min-width:1801px){
.article{  
  margin: 4% 0 3% 4%;
  }
.figure{
  margin: 1% 0 0 1%;
  padding: 10% 4% 8% 5%;
  }
}
</style>